import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import PageTitle from 'components/page-title';
import ItemsTab from './components/items-tab';
import OrdersTab from './components/orders-tab';

const TAB_KEYS = ['items', 'orders'];

const StarShopPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'items';
  const activeKey = TAB_KEYS.includes(tab) ? tab : 'items';

  return (
    <div>
      <PageTitle title="Cửa hàng Sao" />
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setSearchParams(key === 'items' ? {} : { tab: key })}
        destroyInactiveTabPane
        items={[
          { key: 'items', label: 'Món quà', children: <ItemsTab /> },
          { key: 'orders', label: 'Đơn đổi quà', children: <OrdersTab /> },
        ]}
      />
    </div>
  );
};

export default StarShopPage;
